"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'app.pagination.pagnation_info': 'Pokazuję {startItem} do {endItem} z {totalItems} wyników',
};
